<template>
	<div class="servercenter">
		
			<div class="img">
				<img src="http://www.welbell.com/img/N-dncsf_SoaRjKzTDCt9OA20180911164641.jpg"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<i class="el-icon-setting"></i>&nbsp; &nbsp;<router-link to='/Index'><span>首页>> </span></router-link>
					{{sel7?sel7:''}}
				</div>
				
				<!--内容-->
				<div class="content">
					<div class="title">
						<ul>
								<li @click="selItem(item)" 
								:class="sel7===item.title?'active':''" 
								v-for="(item,index) in navlist"
								:key="index" >
								{{item.title}}
								</li>
								
						</ul>
							
					</div>
					<router-view/>		
					
				</div>
				
			</div>
			
	
		
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'newcenter',
				navlist: [
							{
								title: '咨询服务',
								rou: '/ServiceCenter/'
							},
							{
								title: '售后服务',
								rou: '/ServiceCenter/Costomer'
							},
//							{
//								title: '下载中心',
//								rou: '/Loading'
//							},
							{
								title: '网络保修',
								rou: '/ServiceCenter/Repair'
							},
						
				],
				sel7:'咨询服务',
				sel:''
			}
		},
		methods:{
			getData(){
				this.sel7 = this.$route.params.sel7;
			},
			selItem(item) {
				this.sel7 = item.title; 
			
				this.$router.push(item.rou);
			}
		},
		created(){
			this.getData();
		}

	}
</script>

<style lang="less" scoped="scoped">
.servercenter{
	.img{
		width:100%;
		height:350px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
		.news{
			width: 100px;
			height: 40px;
			color: forestgreen;
			margin-left: 5px;
			margin-right: 5px;
		}
	}
		.content{
		margin-top: 50px;
		.title{
			text-align: center;
			ul{
				li{
					display: inline-block;
					margin-left: 40px;
					width: 120px;
					height: 40px;	
					background: #eee;	
					text-align: center;
					line-height: 40px;	
				}
				.active{
					background: #00A0FF;
					color: #fff;
				}
			}
			P{
				margin-top: 50px;
				font-size: 26px;
				color: #00A0FF;
			}
			h3{
				margin-top: 10px;
				font-size: 26px;
				font-weight: 600;
				margin-bottom: 50px;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ServiceCenter/ServiceCenter.vue